export default [
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/pending-asset-register/:pageId',
        component: () => import('@/views/page/company/asset-register/pending-asset-register/List'),
        name: 'pending-asset-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/asset-register/:pageId',
        component: () => import('@/views/page/company/asset-register/asset-register/List'),
        name: 'asset-register',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/asset-register-add/:pageId',
        component: () => import('@/views/page/company/asset-register/asset-register/Add'),
        name: 'asset-register-add',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/my-assets/:pageId',
        component: () => import('@/views/page/company/asset-register/my-assets/List'),
        name: 'my-assets',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/asset-depreciation-process/:pageId',
        component: () => import('@/views/page/company/asset-register/depreciation/Process'),
        name: 'asset-depreciation-process',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/asset-schedule-report/:pageId',
        component: () => import('@/views/page/company/asset-register/report/AssetScheduleReport'),
        name: 'asset-schedule-report',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/depreciation-journal/:pageId',
        component: () => import('@/views/page/company/asset-register/depreciation-journal/List'),
        name: 'depreciation-journal',
        meta: {
            requiresAuth: true
        }
    },
    {
        path: '/company/:companyId/module/:moduleId/menu/:menuId/depreciation-journal-create/:processTrackerId/:pageId',
        component: () => import('@/views/page/company/asset-register/depreciation-journal/CreateJournal'),
        name: 'depreciation-journal-create',
        meta: {
            requiresAuth: true
        }
    },
]